// extracted by mini-css-extract-plugin
export default {"container":"YYnf4IttbYw4I1a651OJ","filters":"qo1DwIpmdSAw64XyYn09","footer":"lkl6LVE6j618dKeIjdLh","tag":"FnHag3FbdFUQFH3Pmp5Q","activeTag":"kPKJdC1GypzXKE7wJS6D"};